import "../styles/carousel.css";
import carousel1 from "../assets/images/carousel1.jpeg"
import carousel2 from "../assets/images/carousel2.jpeg"
import carousel3 from "../assets/images/carousel3.jpeg"
import carousel4 from "../assets/images/carousel4.jpeg"
import carousel5 from "../assets/images/carousel5.jpeg"
import carousel6 from "../assets/images/carousel6.jpeg"
import carousel7 from "../assets/images/carousel7.jpeg"
import carousel8 from "../assets/images/carousel8.jpeg"
import carousel9 from "../assets/images/carousel9.jpeg"
import carousel10 from "../assets/images/carousel10.jpeg"
import carousel11 from "../assets/images/carousel11.jpeg"
import carousel12 from "../assets/images/carousel12.jpeg"
import carousel13 from "../assets/images/carousel13.jpeg"

const images = [
    carousel1,carousel2,carousel3,carousel4,carousel5,carousel6,carousel7,carousel8,
    carousel9,carousel10,carousel11,carousel12,carousel13
];

const Carousel = () => {
  // Duplicate images to create infinite effect
  const loopImages = [...images, ...images];

  return (
    <div className="carousel-section">

      <div className="carousel-wrapper">
        <div className="carousel-track">
          {loopImages.map((src, i) => (
            <div className="carousel-card" key={i}>
              <img  src={src} alt={`carousel-${i}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
